<template>
  <div class="view">
    <div class="formtabtop">
      <div class="titlel">报表</div>
      <el-button type="primary" @click="back" size="mini">返回</el-button>
    </div>
    <div class="formtabcon">
      <div class="left1">
        <el-form :inline="true" :model="listData" class="form-inline">
          <el-form-item>
            <el-input v-model="listData.name" placeholder="请输入员工姓名" size="small">
              <!-- <i slot="suffix" class="el-input__icon el-icon-search"></i> -->
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="dataTime"
              type="daterange"
              range-separator="-"
              start-placeholder="提交开始日期"
              end-placeholder="提交结束日期"
              size="small"
              :picker-options="pickerOptions1"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchFn" size="mini">搜索</el-button>
          </el-form-item>
        </el-form>
        <div class="title1">表单提交总数（共{{count}}份数据）</div>
        <div class="echarts_index" id="echarts_index" style="height:250px"></div>
      </div>
      <div class="right1">
        <div class="title1">员工榜单</div>
        <el-table :data="rank">
          <el-table-column type="index" label="排名" width="85"></el-table-column>
          <el-table-column prop="name" label="业务员"></el-table-column>
          <el-table-column prop="number" label="表单总数"></el-table-column>
          <el-table-column  label="单选结果列表">
             <template slot-scope="scope">
               <el-popover
                  placement="right"
                  title=""
                  width="230"
                  trigger="hover"
                >
                    <template v-if="scope.row.radio_list && scope.row.radio_list.length > 0">
                      <div  v-for="(item ,index) in scope.row.radio_list" :key="index" class="info-box">
                        <p >{{item.title}}</p>
                        <div>
                          <p v-for="(item2 ,index) in item.answer" :key="index">
                            {{item2.label}}：{{item2.num}}
                          </p>
                        </div>
                      </div>
                
                    </template>
                    <template v-else>
                      <p>暂无信息</p>
                    </template>
                   
                  <div slot="reference" class="cblue">查看详情</div>
                </el-popover>
              </template>
          </el-table-column>
          <el-table-column   label="多选结果列表">
              <template slot-scope="scope">
               <el-popover
                  placement="right"
                  title=""
                  width="160"
                  trigger="hover"
                >
                <template v-if="scope.row.multiple_list && scope.row.multiple_list.length > 0">
                  <div  v-for="(item ,index) in scope.row.multiple_list" :key="index" class="info-box">
                    <p >{{item.title}}</p>
                    <div>
                      <p v-for="(item2 ,index) in item.answer" :key="index">
                        {{item2.label}}：{{item2.num}}
                      </p>
                    </div>
                  </div>
            
                </template>
                <template v-else>
                  <p>暂无信息</p>
                </template>
                    
                  <div slot="reference" class="cblue">查看详情</div>
                </el-popover>
              </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="formbottom">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="员工"></el-table-column>
        <el-table-column prop="depart" label="部门"></el-table-column>
        <el-table-column prop="nickName" label="提交客户"></el-table-column>
        <el-table-column prop="create_time" label="提交时间"></el-table-column>
        <el-table-column prop="source" label="来源"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showdetails(scope.row.id)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pag_wrap">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :page-size="page.pagesize"
          :current-page="page.pageindex"
          :total="page.total"
          @current-change="pageIndexChange"
        ></el-pagination>
      </div>
    </div>
    <div class="form-detail-r" :class="fdshow?'on':''">
      <div class="top1">
        <div class="title1">数据详情</div>
        <div class="close" @click="closefd">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box1">
        <div class="title2">员工信息</div>
        <div class="item1">
          <div class="label1">员工</div>
          <div class="content1">{{employee.name}}</div>
        </div>
        <div class="item1">
          <div class="label1">部门</div>
          <div class="content1">{{employee.depart}}</div>
        </div>
        <div class="title2" style="margin-top:30px">客户提交信息</div>
        <div class="item1">
          <div class="label1">提交客户</div>
          <img v-if="user" :src="user.avatar" alt />
          <div class="content1"><template v-if="user">{{user.nickName}}</template></div>
        </div>
        <div class="item1" v-for="(item,index) in infolist" :key="index" :style="item.type==9?'align-items: flex-start':''">
          <div class="label1">{{item.content.name}} </div>
          <div class="content1">
            <template v-if="item.type==9">
              <template v-for="(itema, idx) in item.content.imgs">
                <img v-if="itema" :key="idx" :src="itema" class="img1">
              </template>
              <!-- <div v-if="item.content.imgs.length>0" class="mt-10"><el-button type="primary" size="small" @click="onDownload(index)">下载图片</el-button></div> -->
            </template>
            <span v-else-if="item.type==10">{{item.content.address}}</span>
            <span v-else style="margin-right:10px">{{item.content.value}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api.js";
import { yeartime, yeartime_ } from "@/assets/js/common";
import { pagination } from "@/util/util.js";
import JSZip from "jszip";
import FileSaver from "file-saver";
var echarts = require("echarts");
export default {
  name: "formtable",
  data() {
    return {
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now(); //  - 8.64e7 减去就是不包含今天的
        }
      },
      infolist: [],
      count: "",
      fdshow: false,
      tableData: [],
      diary: [],
      employee: {},
      user: {},
      rank: [],
      emlist: [],
      allpage: 0,
      listData: {
        page: 1,
        form_id: this.$route.query.id,
        name:'',
        start_time:'',
        end_time:'',
      }, // 列表数据
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      },
      dataTime: []
    };
  },
  created() {
    const loading = this.$loading({
      lock: true,
      text: "加载中…",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.4)",
      customClass: "fontColor"
    });
    this.InitFn(loading);
    // this.getdata();
  },
  methods: {
    InitFn(loading) {
      // 创建执行
      this.listData.page = this.page.pageindex;
      this.axios
        .post(api.companyadmin_form_reportNew, this.listData)
        .then(response => {
          // console.log('1111--表单报表--',response)
          if (response.data.code == 0) {
            this.tableData = response.data.list;
            this.page.total = response.data.all_page;
            this.count = response.data.count;
            this.diary = response.data.diary;
            this.rank = response.data.rank;
            this.echarts();
            loading.close();
          } else {
          }
        })
        .catch(() => {});
    },
    // getdata() {
    //   this.axios
    //     .post(api.companyadmin_form_report, this.listData)
    //     .then(response => {
    //       if (response.data.code == 0) {
    //         this.count = response.data.info.count;
    //         this.diary = response.data.info.diary;
    //         this.rank = response.data.info.rank;
    //         this.echarts();
    //       } else {
    //       }
    //     })
    //     .catch(() => {});
    // },
    echarts() {
      let dataList = [];
      let TimeList = [];
      for (let i in this.diary) {
        TimeList.push(this.diary[i].date);
        dataList.push(this.diary[i].num);
      }

      var myChart = echarts.init(document.getElementById("echarts_index"));
      let option = {
        tooltip: {
          trigger: "axis"
        },
        grid: {
          top: "8%",
          left: "0%",
          right: "3%",
          bottom: "0%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: TimeList
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "提交订单数",
            type: "line",
            itemStyle: {
              normal: {
                color: "#5aa9f3",
                lineStyle: {
                  color: "#5aa9f3"
                }
              }
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#bbd9f6"
                  }
                ])
              }
            },
            stack: "总量",
            data: dataList
          }
        ]
      };
      myChart.setOption(option);
    },
    // 分页
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      const loading = this.$loading({
        lock: true,
        text: "加载中…",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.4)",
        customClass: "fontColor"
      });
      this.InitFn(loading);
    },
    handleCurrentChange(val) {
      const loading = this.$loading({
        lock: true,
        text: "加载中…",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.4)",
        customClass: "fontColor"
      });
      this.page.pageindex = val;
      this.InitFn(loading);
    },
    searchFn() {
      this.listData.page = 1;
      if (this.dataTime) {
        if (this.dataTime.length !== 0) {
          this.listData.start_time = yeartime_(this.dataTime[0]);
          this.listData.end_time = yeartime_(this.dataTime[1]);
        } else {
          this.listData.start_time = "";
          this.listData.end_time = "";
        }
      } else {
        this.listData.start_time = "";
        this.listData.end_time = "";
      }
      this.InitFn();
    },
    showdetails(e) {
      this.axios
        .post(api.companyadmin_form_fdetail, { data_id: e })
        .then(response => {
          if (response.data.code == 0) {
            var arr = response.data.info.page_content;
            for (let i in arr) {
              if (arr[i].type == 7) {
                if (arr[i].content.radio == 1) {
                  arr[i].content.name = arr[i].content.name1;
                  for (let j in arr[i].content.list2) {
                    if (arr[i].content.list2[j].checked == true) {
                      arr[i].content.value = arr[i].content.list2[j].label;
                    }
                  }
                } else {
                  arr[i].content.name = arr[i].content.name2;
                  for (let j in arr[i].content.list) {
                    if (arr[i].content.list[j].checked == true) {
                      arr[i].content.value = arr[i].content.list[j].label;
                    }
                  }
                }
              } else if (arr[i].type == 6) {
                for (let j in arr[i].content.list) {
                  if (arr[i].content.list[j].checked == true) {
                    arr[i].content.value = arr[i].content.list[j].label;
                  }
                }
              } else if (arr[i].type == 8) {
                for (let j in arr[i].content.list) {
                  if (arr[i].content.list[j].checked == true) {
                    arr[i].content.value = arr[i].content.list[j].label;
                  }
                }
              }
            }
            this.employee = response.data.info.employee;
            this.user = response.data.info.user;
            this.infolist = arr;

            this.fdshow = true;
          } else {
          }
        })
        .catch(() => {});
    },
    closefd() {
      this.fdshow = false;
    },
    back() {
      this.$router.go(-1);
    },
    // 下载图片
    onDownload(index) {
      var blogTitle = '表单报表图片';
      var zip = new JSZip();
      var imgs = zip.folder(blogTitle);
      var baseList = [];
      // 要下载图片的url
      var arr = this.infolist[index].content.imgs;
      // var arr = ['/static/img/login/logosmall.png', '/static/img/image.png', '/static/img/document.png']
      // 下载后图片的文件名，个数应与arr对应
      var imgNameList = [];
      for (var i = 0; i < arr.length; i++) {
        if (arr[i]) {
          imgNameList.push('img_' + (i + 1));
          // let image = new Image();
          // image.setAttribute('crossOrigin', 'anonymous');
          // image.onload = function (e) {
          //   let canvas = document.createElement('canvas');
          //   canvas.width = image.width;
          //   canvas.height = image.height;
          //   let context = canvas.getContext('2d');
          //   context.drawImage(image, 0, 0, image.width, image.height);
            // let url = canvas.toDataURL(); // 得到图片的base64编码数据
            // canvas.toDataURL('image/png');
            // baseList.push(url.substring(22));    // 去掉base64编码前的 data:image/png;base64,
            baseList.push(arr[i].substring(22));    // 去掉base64编码前的 data:image/png;base64,
            if (baseList.length === arr.length && baseList.length > 0) {
              for (let k = 0; k < baseList.length; k++) {
                imgs.file(imgNameList[k] + '.png', baseList[k], {base64: true})
              }
              zip.generateAsync({type: 'blob'}).then(function (content) {
                // see FileSaver.js
                FileSaver.saveAs(content, blogTitle + '.zip');
              });
            }
          // };
          // image.src = arr[i];
        }
      }
    }
  }
};
</script>